import React, { useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import './style.sass'
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'

import { useIsMobile } from 'hooks/useIsMobile';
import { decodeStorage } from 'functions/storageBase64';
import { MenuCredito } from 'components/menuCredito';

import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import ModalLoading from 'components/Loading';
import ValidarCodigo from './validarCodigo.js';
import IngresarNumero from './ingresarNumero.js';

import { getVerificarPhone, getEnviarOTP } from 'services/verificarCreditoCS';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';


const useCountTimer = (initialTimer) => {
    
    let totalSegundos = initialTimer ? initialTimer : 60

    const [valTimer, setValTimer] = useState(0)
    const [timer, setTimer] = useState(null)
    const [timerIsActive, setTimerIsActive] = useState(false)
    const [timerIsZero, setTimerIsZero] = useState(false)

    const zero = (num) => (num < 10 ? `0${num}` : num)

    let secsToMinSecs = (totalSegundos) => {
        let minutes = Math.floor(totalSegundos / 60)
        let seconds = totalSegundos - minutes * 60
        return zero(minutes) + ":" + zero(seconds)
    }
    
    useEffect(() => {
        if(timerIsActive){
            setValTimer(totalSegundos)  
        }
    },[timerIsActive])
    
    useEffect(() => {
        if(valTimer > 0){
            setTimeout(() => {
                setValTimer(valTimer - 1)  
            }, 1000)
            setTimer(secsToMinSecs(valTimer))
            setTimerIsZero(false)
        }
        else{
            setTimerIsActive(false)
            setTimerIsZero(true)
            setTimer(secsToMinSecs(valTimer))
        }
    },[valTimer])


    const startTimer = () => {
        setTimerIsActive(true)
    }

    return {
        startTimer,
        timer,
        timerIsZero
    }
}


export default function VerificacionOTP() {

    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const session_token = decodeStorage('session_token');

    //variables
    const [numero, setNumero] = useState(false);
    const [keySMS, setKeySMS] = useState(false);
    const [flagActivarContador, setFlagActivarContador] = useState(false);
    const [mostrarPaso2, setMostrarPaso2] = useState(false);

    const [keyEnviado, setKeyEnviado]= useState(false);
    const [numeroEnviado, setNumeroEnviado] = useState(false);

    // para el contador
    const [estaVencido, setEstaVencido] = useState(false);
    const [codigoInvalido, setCodigoInvalido] = useState(false); //muestra si el codigo ingresado es valido o no
    const [activarReenvio, setActivarReenvio] = useState(false); // activa desactiva boton de reenvio
    const [mostrarCopy, setMostrarCopy] = useState(false); // muestra copy contrador en boton de reenvio

    const {
        startTimer,
        timer: tiempo,
        timerIsZero
    } =  useCountTimer(180)


    const [phone, setPhone] = useState()
    useEffect(() => {
        window.scrollTo(0, 0);
        setLoading(true)
        if(session_token){
            getVerificarPhone(session_token)
            .then(setPhone)
        }
    }, []);
    
    const [phoneOTP, setPhoneOTP] = useState()
    const [preNumero, setPreNumero] = useState(true)

    let resopseOTP = {
        "metadata": {
            "is_error": false,
            "http_status": 200,
            "http_status_phrase": "OK",
            "time": 1702426262,
            "message": "OK"
        },
        "data": {
            "mobile": "5540730561",
            "error_code": 0,
            "code_length": 6,
            "message": "C\u00f3digo enviado",
            "key": "4d536bf9-5985-4f70-b931-d38acfa90a24",
            "status": true
        },
        "pagination": {
            "total_items": 0,
            "total_pages": 0,
            "current_page": 0,
            "items_per_page": 0
        }
    }

    useEffect(()=> {
        if(phone){
            if(phone.statusCode === 412){
                getEnviarOTP(session_token, 'whatsapp')
                .then(setPhoneOTP)
                setPreNumero(false)

                // console.log('enviar : ',  resopseOTP)
                // setPhoneOTP(resopseOTP)
            }else if(phone.statusCode === 200){
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
            }
            else{
                setLoading(false)
            }
        }
    },[phone])

    useEffect(()=> {
        if(phoneOTP){
            if(phoneOTP?.data){
                setLoading(false)
                setMostrarPaso2(true)
                setFlagActivarContador(true)
                activarContador()
                setKeySMS(phoneOTP?.data?.data?.key);
                setNumero(phoneOTP?.data?.data?.mobile);
            }
        }
    },[phoneOTP])


    const activarContador = () => {
        startTimer()
        setEstaVencido(false)
        setCodigoInvalido(false)
        setMostrarCopy(true)
    }
    useEffect(() => {
        if (timerIsZero) {
            setEstaVencido(true)
            setActivarReenvio(true)
            setMostrarCopy(false)
        }
        else {
            setActivarReenvio(false);
        }
    }, [timerIsZero]);


    useEffect((
    )=>{
        // if(keySMS && numero){
            setNumeroEnviado(numero);
            setKeyEnviado(keySMS);
            // console.log("key en padre: ", keySMS)
        // }
    },[keySMS, numero])

    return (
        <>
            {loading && <ModalLoading />}

            {isMobile === "desktop"
                ? <>
                    <Header type="complete" />
                    <main>
                        <section className="sectionPrincipal">
                            <MenuCredito />
                            <div className="contenido">
                                <div className="boxGeneralHomeDesk">
                                    {mostrarPaso2 === false
                                        ? <IngresarNumero
                                            setMostrarPaso2={setMostrarPaso2}
                                            setLoading={setLoading}
                                            setNumero={setNumero}
                                            setFlagActivarContador={setFlagActivarContador}
                                            activarContador={activarContador}
                                            setKeySMS={setKeySMS}
                                        />
                                        : <ValidarCodigo
                                            numeroTelefono={numeroEnviado} 
                                            tiempo={tiempo}
                                            setMostrarPaso2={setMostrarPaso2}
                                            activarContador={activarContador}
                                            mostrarCopy={mostrarCopy}
                                            setLoading={setLoading}
                                            keySMS={keySMS}
                                            estaVencido={estaVencido}
                                            codigoInvalido={codigoInvalido}
                                            setCodigoInvalido={setCodigoInvalido}
                                            setEstaVencido={setEstaVencido}
                                            preNumero={preNumero}
                                        />
                                    }
                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer type="complete" />
                </>
                : <>
                    <div className="homeMobile">
                        <Header type="complete" />
                        <HeaderMobileCredito title="Mi crédito Claroshop" type="backFull" valToken={false} />
                        <div className="contenedorGeneral homeCverificar">
                            {mostrarPaso2 === false
                                ? <IngresarNumero
                                    setMostrarPaso2={setMostrarPaso2}
                                    setLoading={setLoading}
                                    setNumero={setNumero}
                                    setFlagActivarContador={setFlagActivarContador}
                                    activarContador={activarContador}
                                    setKeySMS={setKeySMS}
                                />
                                : <ValidarCodigo
                                    numeroTelefono={numeroEnviado} 
                                    tiempo={tiempo}
                                    setMostrarPaso2={setMostrarPaso2}
                                    activarContador={activarContador}
                                    mostrarCopy={mostrarCopy}
                                    setLoading={setLoading}
                                    keySMS={keySMS}
                                    estaVencido={estaVencido}
                                    codigoInvalido={codigoInvalido}
                                    setCodigoInvalido={setCodigoInvalido}
                                    setEstaVencido={setEstaVencido}
                                    preNumero={preNumero}
                                />
                            }
                        </div>
                    </div>
                </>
            }
        </>
    )
}